import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "@opendate-app/setlist";

const SegmentAudienceWarningModal = ({ pendingSegment, channel, onCancel, onConfirm }) => {
  const lastSegment = useRef(pendingSegment);
  if (pendingSegment) lastSegment.current = pendingSegment;
  const segment = lastSegment.current;

  if (!segment) return null;

  return (
    <Modal
      open={!!pendingSegment}
      onClose={onCancel}
      type="warning"
      role="alertdialog"
      width={440}
      title="Send to your full segment?"
      description={(
        <>
          “{segment.label}” is a saved segment. This automation will {channel} every
          fan in it <b>each time the trigger fires</b> — not just fans tied to the triggering
          event. On a busy calendar that can mean repeated {channel === "text" ? "texts" : "emails"} to
          your whole list.
        </>
      )}
      footer={(
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button variant="primary" onClick={() => pendingSegment && onConfirm(pendingSegment)}>Yes, use this segment</Button>
        </>
      )}
    />
  );
};

SegmentAudienceWarningModal.propTypes = {
  pendingSegment: PropTypes.shape({
    segmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
  }),
  channel: PropTypes.oneOf(["email", "text"]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default SegmentAudienceWarningModal;
